module.exports = __webpack_public_path__ + "static/img/01.8cf1db5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/hugelshofer/01.jpg
// module id = 388
// module chunks = 1